import React, { memo } from "react";
import { CCard } from "@coreui/react";
import { getRiskClassifierClass } from "src/views/projectdetails/ProjectTask";
import { getColSpanClasses } from "src/utils/getColSpanClasses";

export const TaskItem = memo(({
  task,
  taskIndex,
  phaseIndex,
  className = "",
  style,
  cardClassName = "",
  cardStyle,
  taskTitle,
  metrics,
  rightActions,
}) => {
  if (!task) return null;

  const classifierClass = getRiskClassifierClass(task.risk_score);

  const renderedMetrics = typeof metrics === "function"
    ? metrics(task, { taskIndex, phaseIndex })
    : metrics;

  return (
    <div
      className={`w-full ${className}`}
      style={{ padding: "0px", ...style }}
    >
      <div className={classifierClass}></div>

      <CCard
        id={`task-${task.sow_id ?? task.id}`}
        className={`p-[10px] rounded-none shadow-[0px_3px_6px_#23303d77] hover:bg-gray-50/80 mb-[1px] ${cardClassName}`}
        style={{ marginLeft: "30px", marginBottom: "1px", ...cardStyle }}
      >
        <div className="grid grid-cols-12 items-start">
          <div id="Task" className="col-span-12 md:col-span-3 mb-2 md:mb-0 pr-2">
            {taskTitle ? (
              typeof taskTitle === "function" ? taskTitle(task, { taskIndex, phaseIndex }) : taskTitle
            ) : (
              <span className="text-xs text-[#23303d] font-medium leading-relaxed block">
                {task.SOW || task.scope_of_work}
              </span>
            )}
          </div>

          <div
            id="Priority, Status and dates"
            className={`col-span-12 ${rightActions ? "md:col-span-6" : "md:col-span-9"} text-center mb-2 md:mb-0`}
          >
            {Array.isArray(renderedMetrics) ? (
              <div className="grid grid-cols-12 items-start">
                {renderedMetrics.map((col, colIdx) => (
                  <div
                    key={col.id || colIdx}
                    id={col.id}
                    className={`text-center px-1 ${getColSpanClasses(col)} ${col.className || ""}`.trim()}
                  >
                    {col.items ? (
                      <div className="flex flex-col space-y-2">
                        {col.items.map((item, itemIdx) => (
                          <div key={item.id || itemIdx}>
                            <span className="text-[10px] text-gray-500 font-medium leading-tight block">
                              {item.label}
                            </span>
                            <div className="text-sm text-gray-800 font-medium mt-0.5">
                              {item.value}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {col.label && (
                          <span className="text-[10px] text-gray-500 font-medium leading-tight block">
                            {col.label}
                          </span>
                        )}
                        {typeof col.value === "function" ? (
                          col.value(task, { taskIndex, phaseIndex })
                        ) : (
                          col.value ?? (
                            <div className="text-sm text-gray-800 font-medium mt-0.5">
                              {col.text || "---"}
                            </div>
                          )
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              renderedMetrics
            )}
          </div>

          {rightActions && (
            <div className="col-span-12 md:col-span-3 text-center">
              {typeof rightActions === "function" ? rightActions(task, { taskIndex, phaseIndex }) : rightActions}
            </div>
          )}
        </div>
      </CCard>
    </div>
  );
});

export default TaskItem;
